// extracted by mini-css-extract-plugin
export default {"dotsLoader":"LoadingDots_dotsLoader__LX2o0","dots-loader":"LoadingDots_dots-loader__Vkg5h","secondary":"LoadingDots_secondary__kv6Yx"};